export function initProblematiques(){

    var problematiques = Barba.BaseView.extend({
    namespace: 'problematiques',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
    },
    onEnterCompleted: function() {

        $(".radio_business").change(function () {
            if ($(this).is(":checked")){
                var id = $(this).attr("id");
                $(".radio_business:not(#"+id+")").prop("checked", false)
            }

            var data = $('input[name="business"]:checked').val();
            $("#select_business").val(data);

            filterReals(data);
        })

        $("#select_business").change(function () {
            var data = $(this).val();
            $(".radio_business").prop("checked", false)
            $("#" + data).prop('checked', true);

            filterReals(data);
        })

        if ($("#preselect").length > 0){
            var slug = $("#preselect").val();
            if ($("#"+slug).length > 0){
                $("#"+slug).prop("checked", true);
                $("#select_business").val(slug);
                filterReals(slug);
            }
        }

        // preselect page problematiques
        setTimeout(function () {
          var url = new URL(location.href);
          var tab = url.searchParams.get("tab")
          if (tab != null) {
            switch_tab(tab)
          }
        }, 500);

        var tab ;
        $('.switch_tab').on("click",function(){
          tab = $(this).data("show");
          switch_tab(tab)
        })

        function switch_tab(tab){
          $(".type-list li").removeClass("active");
          $("#"+tab).addClass('active');

          $(".problematiques-list").hide();
          $("#problems_"+tab).show();
        }

    }
  });
  // Don't forget to init the view!
  problematiques.init();

    function filterReals(data) {
        $.post({
            url: $("section.problematiques").data("ajaxurl"),
            data : {value: data},
            success : function (response) {
                $(".problematiques-list").remove();
                $("section.problematiques .container").append(response);

                var toShow = $(".type-problematiques ul li:not(.active) a").data("show");
                $(toShow).hide();
            }
        })
    }


}
